var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImagePageLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1706985872257,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 7530,
    id: "mx_n_1706985872258",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M760.685714 716.8c1.828571 0 3.657143-1.828571 3.657143-3.657143V310.857143c0-1.828571-1.828571-3.657143-3.657143-3.657143H265.142857c-1.828571 0-3.657143 1.828571-3.657143 3.657143v402.285714c0 1.828571 1.828571 3.657143 3.657143 3.657143h495.542857zM923.428571 512c0 226.742857-184.685714 411.428571-411.428571 411.428571S100.571429 738.742857 100.571429 512 285.257143 100.571429 512 100.571429 923.428571 285.257143 923.428571 512z m-610.742857 148.114286L457.142857 400.457143l74.971429 124.342857 60.342857-42.057143 118.857143 179.2-398.628572-1.828571z m376.685715-259.657143c0 20.114286-16.457143 34.742857-34.742858 34.742857-20.114286 0-34.742857-16.457143-34.742857-34.742857s16.457143-34.742857 34.742857-34.742857c18.285714-1.828571 34.742857 14.628571 34.742858 34.742857z m51.2-71.314286h-457.142858v365.714286h455.314286V329.142857z",
    fill: "#66c6f9",
    "p-id": 7531
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagePageLogo);
export default __webpack_public_path__ + "static/media/image-page-logo.1fd1b27a6faf53ae314af5c1bb313520.svg";
export { ForwardRef as ReactComponent };